import {
    ChangeDetectorRef,
    Component,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProductTypeResponseInterface } from '../../../../interfaces/product-type-response.interface';
import { PackageResponseInterface } from '../../../../interfaces/package-response.interface';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { CountryService } from '../../../services/country.service';
import {
    optClassification2,
    optClassification3,
    ClassificationOption,
    optProductiveStage,
} from '../../../common/utils/classification-data';
import { RegistroService } from '../../../registro.service';
import { Species } from '../../../../interfaces/species-response.interface';
import { firstValueFrom } from 'rxjs';
import { ClasificacionService } from '../../services/clasificacionProductos';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-addProduct',
    templateUrl: './add-product.component.html',
    styleUrls: ['./add-product.component.css'],
})
export class AddProductComponent {
    @ViewChild('productoForm') productoForm!: NgForm;
    optProductType: any[] = [];
    optPackaging: any[] = [];
    optUnitsOfMeasurement: any[] = [];
    productoGuardado = false;
    mostrarFormulario = true;
    casaProductora = '';
    lastSelectedEmpaque: number = null;
    activeIngredient = '';
    toxicologicalClassification: number = null;
    productClassification = '';
    concentration = '';
    fertiConcentration = '';
    fertiyCountryOrigin: any;
    countryOrigin: any;
    classification1: number;
    classification2 = '';
    classification3 = '';
    optToxicologicalClassification: ClassificationOption[] = [];
    optProductClassification: any;
    optClassification1: ClassificationOption[] = [];
    optClassification2: ClassificationOption[] = optClassification2;
    optClassification3: ClassificationOption[] = optClassification3;
    selectedEmpaque: number = null;
    selectedTypeProduct: string = null;
    icaNumber: number = null;
    commercialName = '';
    producerCompanyName = '';
    quantity: number;
    selectedUnity = '';
    codigoSeleccionado: any;
    codeUnitMeasurement: any;
    coadyuvanteCountryOrigin: any;
    coadyuvanteClassification: any;
    optSpecieBalanceFood: Species[] = [];
    optProductiveStage: ClassificationOption[] = optProductiveStage;
    balanceFoodSpecie: number;
    balanceFoodProductiveStage: string;
    fertiyTypeFormulation = '';
    formulationTypeId: number = null;
    importedProduct = false;
    eslabon = '';
    origenDelProducto: any;
    ingredienteActivo: any;
    private apiUrl: string = environment.apiSiriUrl;
    optFormulationType: any[];
    countries: any[];
    optProdClassCoad: any[];
    productTypeName: any;
    acondicionadorEnmiendaCountryOrigin: any;

    constructor(
        private http: HttpClient,
        private registroService: RegistroService,
        private countryService: CountryService,
        private cdr: ChangeDetectorRef,
        private clasificacion: ClasificacionService,
        private translate: TranslateService
    ) {}

    async ngOnInit() {
        await Promise.all([
            this.loadOptTypeProduct(),
            this.loadUnitsOfMeasurement(),
            this.loadSpeciesData(),
            // Se ocultan los siguientes metodos de los campos ocultos
            // this.loadClassificationProduct(),
            // this.loadClassificationProductCoadyuvante(),
            // this.loadFormulationType(),
            this.loadCountries(),
            // this.loadClasification1(),
            // this.loadToxicologicalClassification(),
        ]);
    }

    onProductTypeChange() {
        this.selectedEmpaque = null;
        this.quantity = null;
        this.selectedUnity = null;

        const productMapping = {
            '1': 'plaguicida',
            '2': 'fertilizante',
            '3': 'coadyuvante',
            '4': 'alimentoBalanceado',
            '5': 'acondicionadorEnmienda',
        };

        if (this.selectedTypeProduct in productMapping) {
            this.productTypeName = productMapping[this.selectedTypeProduct];
            this.loadPackaging(this.productTypeName);
        }

        if (this.selectedTypeProduct === '4') {
            this.selectedEmpaque = 5;
            this.quantity = 40;
            this.loadUnitsOfMeasurement();
            this.selectedUnity = '9';
        }
    }

    onChange(event: Event) {
        const target = event.target as HTMLSelectElement;
        const selectedIndex = target.selectedIndex;
        const selectedOption = target.options[selectedIndex];

        if (selectedOption instanceof HTMLOptionElement) {
            this.codigoSeleccionado =
                selectedOption.getAttribute('data-codigo');
        }
    }

    async loadOptTypeProduct() {
        this.http
            .get<
                ProductTypeResponseInterface[]
            >(`${this.apiUrl}tipo-producto/disponibles/${this.registroService.empresaSelected}`)
            .subscribe(
                (response) => {
                    this.optProductType = response;
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de Dropdown 1',
                        error
                    );
                }
            );
    }

    async loadClassificationProductCoadyuvante(): Promise<void> {
        try {
            const response = await firstValueFrom(
                this.http.get<ProductTypeResponseInterface[]>(
                    `${this.apiUrl}tipo-producto/coadyuvante-clasificacion-producto`
                )
            );
            this.optProdClassCoad = response;
            console.log(response);
        } catch (error) {
            console.error(
                'Error al cargar opciones de calsificacion del producto coadyuvante',
                error
            );
        }
    }

    isPositiveNumber(value: number): boolean {
        return value > 0;
    }
    padWithZeros(input: number): string {
        const targetLength = 5;
        const diff = targetLength - input.toString().length;
        if (diff > 0) {
            return '0'.repeat(diff) + input;
        }
        return input.toString();
    }

    loadPackaging(productType: string) {
        this.http
            .get<
                PackageResponseInterface[]
            >(`${this.apiUrl}empaque/${productType}`)
            .subscribe(
                (response) => {
                    this.optPackaging = [...response];
                    console.log('optPackaging', this.optPackaging);
                    this.cdr.detectChanges();
                },
                (error) => {
                    console.error('Error al cargar opciones de empaque', error);
                }
            );
    }

    loadUnitsOfMeasurement() {
        if (this.selectedEmpaque !== this.lastSelectedEmpaque) {
            this.lastSelectedEmpaque = this.selectedEmpaque;
            this.http
                .get<
                    any[]
                >(`${this.apiUrl}unidad-medida/by-empaque/${this.selectedEmpaque}`)
                .subscribe(
                    (response) => {
                        this.optUnitsOfMeasurement = response;
                        this.codigoSeleccionado =
                            this.optUnitsOfMeasurement[0].codigo;
                        this.selectedUnity =
                            this.optUnitsOfMeasurement[0]?.EmpaqueUnidadMedida?.id;
                    },
                    (error) => {
                        console.error(
                            'Error al cargar opciones de unidades de medida',
                            error
                        );
                    }
                );
        }
    }

    private loadClassificationProduct() {
        this.http
            .get<
                any[]
            >(`${this.apiUrl}tipo-producto/plaguicida-clasificacion-producto`)
            .subscribe(
                (response) => {
                    this.optProductClassification = response;
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de clasificacion producto',
                        error
                    );
                }
            );
    }

    onChangeEmpaque() {
        this.loadUnitsOfMeasurement();
    }

    normalizeQuantity(decimals = 1): void {
        if (typeof this.quantity === 'number' && !Number.isNaN(this.quantity)) {
            this.quantity = Number(this.quantity.toFixed(decimals));
        }
    }

    cleanForm() {
        this.productoGuardado = true;
        this.selectedTypeProduct = null;
        this.icaNumber = null;
        this.commercialName = '';
        this.producerCompanyName = '';
        this.selectedEmpaque = null;
        this.quantity = null;
        this.selectedUnity = '';
        this.activeIngredient = '';
        this.toxicologicalClassification = null;
        this.productClassification = '';
        this.countryOrigin = '';
        this.formulationTypeId = null;
        this.concentration = '';
        this.fertiyCountryOrigin = '';
        this.classification1 = undefined;
        this.classification2 = '';
        this.classification3 = '';
        this.fertiyTypeFormulation = '';
        this.fertiConcentration = '';
        this.coadyuvanteCountryOrigin = '';
        this.coadyuvanteClassification = undefined;
        this.balanceFoodSpecie = null;
        this.balanceFoodProductiveStage = '';
        this.importedProduct = false;
        this.origenDelProducto = '';
        this.ingredienteActivo = '';
        this.acondicionadorEnmiendaCountryOrigin = '';
    }

    async onSubmit() {
        if (!this.isPositiveNumber(this.quantity)) {
            Swal.fire(
                'Error',
                'La cantidad debe ser un número positivo',
                'error'
            );
            return;
        }

        if (this.selectedTypeProduct === '4') {
            this.selectedEmpaque = 5;
            this.quantity = 40;
            this.loadUnitsOfMeasurement();
            this.selectedUnity = '9';
        }

        const requiredGeneralFields = [
            {
                field: this.selectedTypeProduct,
                message: 'Tipo de producto es requerido',
            },
            {
                field: this.icaNumber,
                message: 'Número registro ICA es requerido',
            },
            {
                field: this.commercialName,
                message: 'Nombre comercial es requerido',
            },
            {
                field: this.producerCompanyName,
                message: 'Casa productora / Planta productora es requerida',
            },
        ];

        for (const { field, message } of requiredGeneralFields) {
            if (!field) {
                Swal.fire('Error', message, 'error');
                return;
            }
        }
        if (!/^[A-Z0-9]+$/.test(this.icaNumber.toString())) {
            Swal.fire(
                'Error',
                'Número ICA solo debe contener letras mayúsculas y números',
                'error'
            );
            return;
        }

        if (
            this.selectedTypeProduct !== '4' &&
            (!this.selectedEmpaque || !this.selectedUnity || !this.quantity)
        ) {
            Swal.fire(
                'Error',
                'Todos los campos de presentación son requeridos',
                'error'
            );
            return;
        }
        let productSpecificError = '';
        switch (this.selectedTypeProduct) {
            case '1': // Plaguicidas
                if (!this.origenDelProducto) {
                    productSpecificError =
                        'Origen del producto es requerido para plaguicidas';
                }
                break;
            case '2': // Fertilizantes
                if (!this.origenDelProducto) {
                    productSpecificError =
                        'Origen del producto es requerido para fertilizantes';
                }
                break;
            case '3': // Coadyuvantes
                if (!this.origenDelProducto) {
                    productSpecificError =
                        'Origen del producto es requerido para coadyuvantes';
                }
                break;
            case '5': // Acondicionador o enmienda
                if (!this.origenDelProducto) {
                    productSpecificError =
                        'Origen del producto es requerido para acondicionadores o enmiendas';
                }
                break;
        }

        if (productSpecificError) {
            Swal.fire('Error', productSpecificError, 'error');
            return;
        }

        if (this.origenDelProducto === 'Producto Nacional') {
            this.countryOrigin = ' ';
            this.fertiyCountryOrigin = ' ';
            this.coadyuvanteCountryOrigin = ' ';
            this.acondicionadorEnmiendaCountryOrigin = ' ';
        }

        this.codeUnitMeasurement =
            this.selectedEmpaque +
            (this.quantity ? this.padWithZeros(this.quantity) : '') +
            this.codigoSeleccionado;

        const formData = {
            tipoProductoId: +this.selectedTypeProduct,
            agenteVigiladoId: this.registroService.empresaSelected,
            nombreComercial: this.commercialName,
            casaProductora: this.producerCompanyName,
            numeroRegistroIca: this.icaNumber,
            OrigenDelProducto: this.origenDelProducto,
            presentacion: {
                empaqueUnidadMedidaId: this.selectedUnity,
                cantidad: this.quantity,
                codigoPresentacion: this.codeUnitMeasurement,
            },
            tipoProductoEspecifico: {
                tipo: '',
                data: {},
            },
        };

        if (this.classification2 === 'Orgánico') {
            this.classification3 = ' ';
        }

        switch (this.selectedTypeProduct) {
            case '1':
                formData.tipoProductoEspecifico.tipo = 'Plaguicida';
                formData.tipoProductoEspecifico.data = {
                    // Se ocultan los siguientes campos por logica de negocio - HU153
                    // ingredienteActivo: this.activeIngredient,
                    // clasificacionToxicologicaId:
                    //     this.toxicologicalClassification,
                    // clasificacionProductoId: this.productClassification,
                    paisDeOrigen: this.countryOrigin,
                    // tipoFormulacionId: this.formulationTypeId,
                    // concentracion: this.concentration,
                };
                break;
            case '2':
                formData.tipoProductoEspecifico.tipo = 'Fertilizante';
                formData.tipoProductoEspecifico.data = {
                    // Se ocultan los siguientes campos por logica de negocio - HU154
                    paisDeOrigen: this.fertiyCountryOrigin,
                    // clasificacion1Id: this.classification1,
                    // clasificacion_2: this.classification2,
                    // clasificacion_3: this.classification3,
                    // tipoFormulacion: this.fertiyTypeFormulation,
                    // concentracion: this.fertiConcentration,
                };
                break;
            case '3':
                formData.tipoProductoEspecifico.tipo = 'Coadyuvante';
                formData.tipoProductoEspecifico.data = {
                    // Se ocultan los siguientes campos por logica de negocio - HU129
                    paisDeOrigen: this.coadyuvanteCountryOrigin,
                    // ingrediente_activo: this.ingredienteActivo,
                    // clasificacionProductoCoadyuvanteId:
                    //     this.coadyuvanteClassification,
                };
                break;
            case '4':
                // HU130: el tipo de producto id 4 se denomina "Nutrición animal".
                formData.tipoProductoEspecifico.tipo = 'Nutrición animal';
                formData.OrigenDelProducto = 'Producto Nacional';
                formData.tipoProductoEspecifico.data = {
                    especieId: this.balanceFoodSpecie,
                    etapaProductiva: this.balanceFoodProductiveStage,
                };
                break;
            case '5':
                formData.tipoProductoEspecifico.tipo =
                    'Acondicionador o enmienda';
                formData.tipoProductoEspecifico.data = {
                    paisDeOrigen: this.acondicionadorEnmiendaCountryOrigin,
                };
                break;
        }

        try {
            const response = await firstValueFrom(
                this.http.post(`${this.apiUrl}producto`, formData)
            );

            Swal.fire({
                title: '¡Éxito!',
                text: 'El producto se ha creado correctamente',
                icon: 'success',
                confirmButtonText: 'Aceptar',
            }).then(() => {
                this.cleanForm();
                this.mostrarFormulario = false;
            });
        } catch (error) {
            console.error('Error al crear el producto:', error);

            let errorMessage = 'Ocurrió un error al crear el producto';
            if (error.error?.message) {
                if (error.error.message.includes('número de registro ICA')) {
                    Swal.fire(
                        'Producto duplicado',
                        'Ya existe un producto con el mismo número de registro ICA',
                        'warning'
                    );
                } else {
                    errorMessage += `: ${error.error.message}`;
                    Swal.fire('Error', errorMessage, 'error');
                }
            } else {
                Swal.fire('Error', errorMessage, 'error');
            }
        }
    }

    showForm() {
        this.mostrarFormulario = true;
    }

    loadSpeciesData() {
        this.http.get<any[]>(`${this.apiUrl}tipo-producto/especies`).subscribe(
            (response) => {
                this.optSpecieBalanceFood = response;
            },
            (error) => {
                console.error('Error al cargar opciones de Dropdown 2', error);
            }
        );
    }

    async loadToxicologicalClassification() {
        this.optToxicologicalClassification = await firstValueFrom(
            this.clasificacion.loadToxicologicalClassification()
        );
    }

    async loadClasification1() {
        this.optClassification1 = await firstValueFrom(
            this.clasificacion.optClassification1()
        );
    }

    loadCountries() {
        this.countryService.getCountries().subscribe(
            (response) => {
                this.countries = response;
            },
            (error) => {
                console.error('Error loading countries', error);
            }
        );
    }

    loadFormulationType() {
        this.http
            .get<
                any[]
            >(`${this.apiUrl}tipo-producto/tipo-formulacion-plaguicida`)
            .subscribe(
                (response) => {
                    this.optFormulationType = response;
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de tipo de formulacion',
                        error
                    );
                }
            );
    }

    /**
     * Muestra una ventana emergente con información de ayuda sobre el nombre comercial del producto.
     *
     * @returns {void} No retorna ningún valor.
     */
    mostrarTooltipNombreComercial() {
        this.translate
            .get('producto.infoNombreComercial')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }
}
